// Subtle topographic / contour line texture, inspired by the kit sticker.
// Used ONLY as decoration inside hero / accent blocks — never behind body text.
export default function Topography({ color = "#0D1B33", opacity = 0.08, className = "" }) {
  return (
    <svg
      className={className}
      aria-hidden="true"
      focusable="false"
      width="100%"
      height="100%"
      viewBox="0 0 600 400"
      preserveAspectRatio="xMidYMid slice"
      style={{ position: "absolute", inset: 0, pointerEvents: "none", opacity }}
    >
      <g fill="none" stroke={color} strokeWidth="2">
        <path d="M-40 300 C 120 210, 220 360, 360 250 S 620 120, 700 210" />
        <path d="M-40 260 C 120 170, 220 320, 360 210 S 620 80, 700 170" />
        <path d="M-40 220 C 120 130, 220 280, 360 170 S 620 40, 700 130" />
        <path d="M-40 180 C 120 90, 220 240, 360 130 S 620 0, 700 90" />
        <path d="M-40 140 C 120 50, 220 200, 360 90 S 620 -40, 700 50" />
        <path d="M-40 340 C 120 250, 220 400, 360 290 S 620 160, 700 250" />
      </g>
    </svg>
  );
}
